import request from '@/utils/request';
import Resource from '@/api/resource';
class ConvertResource extends Resource {
  constructor() {
    super('tool/convert/gdt');
  }

  // 获取转化
  getConvert(data) {
    return request({
      url: `/${this.uri}?${data}`,
      method: 'GET',
    });
  }

  // 新增转化
  addConvert(data){
    return request({
      url: `/${this.uri}`,
      method: 'POST',
      data,
    });
  }
  // 批量新增转化
  bacthAddConvert(data){
    return request({
      url: `/${this.uri}/batchAdd`,
      method: 'POST',
      data,
    });
  }

  // 获取转化列表
  getConvertListApi(params) {
    return request({
      url: `/${this.uri}`,
      method: 'GET',
      params,
    });
  }
}
export { ConvertResource as default };
